export const jwtLocalStorage = 'IbnAlNafis_JWTtoken';
export const tokenHeaderKey = 'Authorization';
